import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogData } from './dialog-data.model';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'ecu-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
})
export class DialogComponent {
  @Input() title: string;

  @Input() primaryButtonColor: ThemePalette = 'primary';

  @Input() primaryButtonLabel = 'popup.save';
  @Input() secondaryButtonLabel = 'popup.cancel';

  @Input() isPrimaryButtonDisabled: boolean;
  @Input() isPrimaryButtonLoading: boolean;

  @Output() primaryButtonClick = new EventEmitter<Event>();
  @Output() secondaryButtonClick = new EventEmitter<Event>();

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onPrimaryButtonClick(event: Event): void {
    this.primaryButtonClick.emit(event);
  }

  onSecondaryButtonClick(event: Event): void {
    this.secondaryButtonClick.emit(event);
  }
}
